import { defineRouting } from "next-intl/routing";
import { createNavigation } from "next-intl/navigation";

/**
 * Конфиг роутинга next-intl для geo-стека.
 *
 * -  — оба языка имеют префикс (/en, /ka).
 * - Дефолтная локаль EN — это интернациональный магазин по умолчанию.
 * - Грузинская локаль второй пункт.
 *
 *  экспортирует locale-aware , , , .
 * Используй их ВМЕСТО  для:
 *   - LocaleSwitcher (router.replace(pathname, { locale }))
 *   - локализованных Link
 *   - server-side redirect
 */
export const routing = defineRouting({
    locales: ["en", "ka"] as const,
    defaultLocale: "en",
    localePrefix: "always",
});

export type AppLocale = (typeof routing.locales)[number];

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
